import { jsx as o, jsxs as y } from "@emotion/react/jsx-runtime";
import { useState as D, useMemo as T, useEffect as b } from "react";
import { useTheme as x } from "@emotion/react";
import { convertToRgba as g } from "@partoohub/branding";
import { FlatDot as k } from "./variants/flatdot.styled.js";
import { WelcomeLoaderContainer as H, WelcomeLoaderContent as W, WelcomeLoaderText as _ } from "./variants/welcome.styled.js";
import { DotLoaderContainer as v, Dot as E } from "./variants/dot.styled.js";
import { SpinnerLoaderContainer as B, StyledSvg as C, spinnerSizes as I, VIEWBOX_WIDTH as M, VIEWBOX_HEIGHT as w, HALF_VIEWBOX_HEIGHT as L, HALF_VIEWBOX_WIDTH as S, strokeTransition as A, TextLoader as X } from "./variants/spinner.styled.js";
const j = ({
  children: r
}) => /* @__PURE__ */ o(H, { children: /* @__PURE__ */ o(W, { children: /* @__PURE__ */ o(_, { children: r }) }) }), F = ({
  percentage: r = 20,
  text: e,
  label: s,
  color: c = "primary",
  size: a = "small",
  active: u = !0,
  strokeWidth: t = 12,
  trailColor: i = "primary"
}) => {
  const l = x(), h = r === 0 ? 1 : r, n = L - t / 2, m = Math.min(Math.max(h, 0), 100) / 100, d = Math.PI * 2 * n, f = I?.[a] ?? a, p = parseInt(f, 10) / 5 + "px";
  return /* @__PURE__ */ y(B, { children: [
    /* @__PURE__ */ y(C, { active: u, "aria-label": s, "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": r, "aria-valuetext": `${r}%`, viewBox: `0 0 ${M} ${w}`, style: {
      height: I?.[a] ?? a,
      width: I?.[a] ?? a
    }, children: [
      /* @__PURE__ */ o("circle", { cx: S, cy: L, r: n, fill: "none", strokeWidth: t, stroke: l.colors?.[i]?.background ? l.colors[i]?.alpha : i }),
      /* @__PURE__ */ o("circle", { css: A, cx: S, cy: L, r: n, fill: "none", strokeWidth: t, strokeDasharray: d, strokeDashoffset: (1 - m) * d, stroke: l.colors[c]?.background || c, strokeLinecap: "round" })
    ] }),
    e ? /* @__PURE__ */ o(X, { fontSize: p, variant: "bodyXSBold", as: "span", color: c, children: e }) : null
  ] });
}, O = ({
  active: r = !0,
  dots: e = 6,
  color: s = "slate",
  animationDuration: c = 2e3,
  size: a = "8px"
}) => {
  const u = x(), [t, i] = D(0), l = u.colors?.[s]?.background ?? s, h = T(() => (n) => Array.from({
    length: n
  }, (m, d) => {
    const f = Math.abs(t - d) / n, p = g(l, 1 - f);
    return {
      index: d,
      color: d === t ? l : p
    };
  }), [e, t, l]);
  return b(() => {
    const n = setInterval(() => {
      i((m) => (m + 1) % e);
    }, Math.abs(c / e));
    return () => clearInterval(n);
  }, [e]), b(() => {
    t === e && i(0);
  }, [t, e]), /* @__PURE__ */ o(v, { children: h(e).map((n, m) => /* @__PURE__ */ o(E, { size: a, index: m, color: n.color, active: r, animationDuration: c, dots: e }, n.index)) });
}, V = ({
  dots: r = 8,
  color: e = "slate",
  size: s = "4px"
}) => {
  const a = x().colors?.[e]?.background ?? e;
  return /* @__PURE__ */ o(v, { children: Array(r).fill(0).map((u, t) => /* @__PURE__ */ o(k, { index: t, size: s, color: a, dots: r }, `dot-${t}`)) });
}, Q = ({
  variant: r = "spinner",
  ...e
}) => r === "welcome" ? /* @__PURE__ */ o(j, { ...e }) : r === "dot" ? /* @__PURE__ */ o(O, { ...e }) : r === "flatdot" ? /* @__PURE__ */ o(V, { ...e }) : /* @__PURE__ */ o(F, { ...e });
export {
  V as FlatDotLoader,
  Q as Loader
};
